import * as S from './styles'

export type RadioButtonProps = {
  checked: boolean
  onClick?: () => void
}

export const RadioButton = ({ checked, onClick }: RadioButtonProps) => (
  <S.RadioButton checked={checked} onClick={onClick} />
)
